module.exports = __webpack_public_path__ + "static/media/general-electric.0d969f85.svg";